import {clsx as defaultClsx} from 'clsx'
import {twMerge} from '@local/config/tailwind/merge'

export const clsx = (...args) => twMerge(defaultClsx(...args))
